import React from 'react';
import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type DataTableEmptyProps = {
  children?: React.ReactNode;
};

export const DataTableEmpty: React.FC<DataTableEmptyProps> = ({ children }) => {
  const { isEmpty, isLoading, isError, hasSearchQuery } = useDataTableContext();

  if (!isEmpty || isLoading || isError || hasSearchQuery) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      minHeight="100px"
    >
      {children ?? (
        <Copy variant="body" color="primaryText">
          No data available.
        </Copy>
      )}
    </Flex>
  );
};
